import { helpEntryFor } from '@velora/contracts/help-index';

/** Where the top-bar "?" goes from a page: its article, else the Help Center. */
export function helpTargetFor(
  moduleId: string | undefined,
  routePath: string | undefined,
): { href: string; title: string | null } {
  if (moduleId === 'help') return { href: '/help', title: null };
  const hit = helpEntryFor(moduleId, routePath);
  return hit ? { href: `/help/${hit.id}`, title: hit.title } : { href: '/help', title: null };
}
